import { createFileRoute } from '@tanstack/react-router'
import { AdminCardPromos } from '@/components/admin/marketing/AdminCardPromos'

// Bank card promo catalog — admin + manager (see lib/staff-roles.ts and the
// backend adminManagerWrite group in routes.go). The only /admin/marketing/*
// tab a manager can open; MarketingShell hides the rest for that role.
export const Route = createFileRoute('/admin/marketing/card-promos')({
  component: () => <AdminCardPromos />,
})
